// TA-approver audit contract shared by the two program builders, the review
// page, and the summary rail.

/** Server default percentage when MARK_FOR_AUDIT_BASE_PCT_HUMAN is unconfigured. */
export const DEFAULT_HUMAN_AUDIT_PCT = 10;

/**
 * Zero is the seeded, unset value. Only the disable switch stops audits; nonpositive or invalid
 * rates use the server default.
 */
export function isHumanAuditPctUnset(stored: unknown) {
  const pct = Number(String(stored ?? '').trim());
  return !Number.isFinite(pct) || pct <= 0;
}
